import React, { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom'
import AppShell from '../components/AppShell'
import { LEGACY_HASH_ROUTES } from './navigation'
import { DiscoverPage, ListedPage, LaunchpadPage } from './HomePages'
import MarketplacePage from '../features/marketplace/pages/MarketplacePage'
import CollectionsPage from '../features/marketplace/pages/CollectionsPage'
import CollectionPage from '../features/marketplace/pages/CollectionPage'
import NftPage from '../features/marketplace/pages/NftPage'
import AccountPage from '../features/marketplace/pages/AccountPage'
import ActivityPage from '../features/marketplace/pages/ActivityPage'
import SearchPage from '../features/marketplace/pages/SearchPage'
import GalleryPage from '../features/gallery/GalleryPage'
import TradeHubPage from '../features/trade/TradeHubPage'
import SwapPage from '../features/trade/SwapPage'
import BridgePage from '../features/trade/BridgePage'
import TokenPage from '../features/token/TokenPage'
import { CreatorOverviewPage, RevenueTreasuryPage } from '../features/creator/CreatorPages'
import { LaunchCollectionPage, PublicLaunchMintPage } from '../features/launch/LaunchPages'
import { CashierPage, CreatorChannelPage, CreatorChannelsPage, CreatorStudioPage, MySubscriptionsPage, SubscriberLibraryPage } from '../features/subscriptions/SubscriptionsPages'
import { AdminOverviewPage, AdminSubscriptionsPage, CollectionControlPage, LaunchpadControlPage, ModerationPage, OperatorFinancePage, PlatformModulesPage } from '../features/admin/AdminPages'

function LegacyHashRouter(){
 const location=useLocation(),navigate=useNavigate()
 useEffect(()=>{
  const apply=()=>{const key=window.location.hash.replace(/^#\/?/,'').split('?')[0].trim().toLowerCase();const path=LEGACY_HASH_ROUTES[key];if(path&&location.pathname==='/'&&path!=='/')navigate(path,{replace:true})}
  apply();window.addEventListener('hashchange',apply);return()=>window.removeEventListener('hashchange',apply)
 },[location.pathname,navigate])
 return null
}
function LaunchMintRoute(){const {launchId=''}=useParams();return <PublicLaunchMintPage launchId={launchId}/>}
function MarketSurface({children}){return <div className="marketplace-route marketplace-live-parity">{children}</div>}
function NotFound(){return <div className="panel empty-state"><h2>Page not found</h2><p>This route is not part of the unified OnlyRose frontend.</p><a className="primary button-link" href="/">Return to Discover</a></div>}

export default function App(){
 return <><LegacyHashRouter/><AppShell><Routes>
  <Route path="/" element={<DiscoverPage/>}/>
  <Route path="/marketplace" element={<MarketSurface><MarketplacePage/></MarketSurface>}/>
  <Route path="/listed" element={<MarketSurface><ListedPage/></MarketSurface>}/>
  <Route path="/collections" element={<MarketSurface><CollectionsPage/></MarketSurface>}/>
  <Route path="/collection/:address" element={<MarketSurface><CollectionPage/></MarketSurface>}/>
  <Route path="/nft/:assetId" element={<MarketSurface><NftPage/></MarketSurface>}/>
  <Route path="/account/:wallet" element={<MarketSurface><AccountPage/></MarketSurface>}/>
  <Route path="/activity" element={<MarketSurface><ActivityPage/></MarketSurface>}/>
  <Route path="/search" element={<MarketSurface><SearchPage/></MarketSurface>}/>
  <Route path="/launchpad" element={<MarketSurface><LaunchpadPage/></MarketSurface>}/>
  <Route path="/launchpad/:launchId" element={<LaunchMintRoute/>}/>
  <Route path="/gallery" element={<GalleryPage/>}/>
  <Route path="/trade" element={<TradeHubPage/>}/>
  <Route path="/swap" element={<SwapPage/>}/>
  <Route path="/bridge" element={<BridgePage/>}/>
  <Route path="/token" element={<TokenPage/>}/>
  <Route path="/creator" element={<CreatorOverviewPage/>}/>
  <Route path="/launch-collection" element={<LaunchCollectionPage/>}/>
  <Route path="/channels" element={<CreatorChannelsPage/>}/>
  <Route path="/channels/:slug" element={<CreatorChannelPage/>}/>
  <Route path="/subscriptions" element={<MySubscriptionsPage/>}/>
  <Route path="/library" element={<SubscriberLibraryPage/>}/>
  <Route path="/cashier" element={<CashierPage/>}/>
  <Route path="/creator/studio" element={<CreatorStudioPage initialTab="Overview"/>}/>
  <Route path="/creator/tiers" element={<CreatorStudioPage initialTab="Tiers"/>}/>
  <Route path="/creator/content" element={<CreatorStudioPage initialTab="Content"/>}/>
  <Route path="/creator/subscribers" element={<CreatorStudioPage initialTab="Subscribers"/>}/>
  <Route path="/creator/community" element={<CreatorStudioPage initialTab="Community"/>}/>
  <Route path="/creator/events" element={<CreatorStudioPage initialTab="Events"/>}/>
  <Route path="/creator/revenue" element={<CreatorStudioPage initialTab="Revenue"/>}/>
  <Route path="/creator/treasury" element={<RevenueTreasuryPage/>}/>
  <Route path="/admin" element={<AdminOverviewPage/>}/>
  <Route path="/admin/modules" element={<PlatformModulesPage/>}/>
  <Route path="/admin/subscriptions" element={<AdminSubscriptionsPage/>}/>
  <Route path="/admin/moderation" element={<ModerationPage/>}/>
  <Route path="/admin/collections" element={<CollectionControlPage/>}/>
  <Route path="/admin/launchpad" element={<LaunchpadControlPage/>}/>
  <Route path="/admin/operator" element={<OperatorFinancePage/>}/>
  <Route path="/onlyrose-token" element={<Navigate to="/token" replace/>}/>
  <Route path="/my-nfts" element={<Navigate to="/gallery" replace/>}/>
  <Route path="*" element={<NotFound/>}/>
 </Routes></AppShell></>
}
